import React, { useState, useEffect } from "react";
import axios from "axios";

import { Container, Offcanvas, Row, Col } from "react-bootstrap";
import AlertComp from "../alert";
import ImageUpload from "./image-upload";
import ProductForm from "./form";
import SpinnerComp from "../spinner";
import { toast, ToastContainer } from 'react-toastify';


// SVG
import { ReactComponent as ArrowLeft } from "../../static/images/svg/Arrow left.svg";

const ProductCanvas = ({
  placement,
  show,
  setShow,
  product,
  handleShouldFetchAgain,
  token,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState("");

  const [formData, setFormData] = useState({
    status: "" ,
    rescheduleDate: "",
    image: null,
  });

  const [canvasWidth, setCanvasWidth] = useState('40%');

  useEffect(() => {
    const updateCanvasWidth = () => {
      if (window.innerWidth <= 768) {
        setCanvasWidth('90%'); // Mobile view
      } else {
        setCanvasWidth('40%'); // Desktop view
      }
    };

    // Set initial width
    updateCanvasWidth();

    // Listen for resize events
    window.addEventListener('resize', updateCanvasWidth);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('resize', updateCanvasWidth);
    };
  }, []);
  const handleChange = (e) => {
    const { name, value, files } = e.target || {};
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: files ? files[0] : value,
    }));
  };

  const handleDropdownChange = (selectedOption) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      status: selectedOption?.value || "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrorText("");

    const form = new FormData();
    form.append("status", formData.status);
    if (formData.status === "rescheduled") {
      form.append("rescheduleDate", formData.rescheduleDate);
    }
    if (formData.image) {
      form.append("image", formData.image);
    }
  // Validate image upload
  else  {
    toast.error("Image is required.");
    setLoading(false);
    return;
  }
    try {
		console.log(product);
		
      const response = await axios.post(
        `${process.env.REACT_APP_DEV_BACKEND_URL}/shipment/${product._id}/status`,
        form,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
	  console.log(response);
	  
      if (response.status && (response.status === 200 || response.status === 202)) {
		toast.success('Status updated successfully!');
        handleShouldFetchAgain();
        setShow(false);
      }
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    } catch (error) {
      setErrorText("Error occurred while saving the product.");
      console.error(error);
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  };

  return (
    <Offcanvas show={show} onHide={() => setShow(false)} placement={placement} style={{ width: canvasWidth }}>
      <Offcanvas.Body>
        {loading ? (
          <SpinnerComp />
        ) : (
          <>
            <Container>
			<ToastContainer />

              <div className="d-flex align-items-center heading-container">
                <ArrowLeft onClick={() => setShow(false)} style={{ cursor: "pointer" }} />
                <h3 className="ms-1">{product ? "Edit Status" : "Update Status"}</h3>
              </div>
              <hr />
              <Row>
                <Col md={4}>
                  <ImageUpload handleChange={handleChange} />
                </Col>
                <Col md={8}>
                  <ProductForm
                    formData={formData}
                    handleChange={handleChange}
                    handleDropdownChange={handleDropdownChange}
                    handleSubmit={handleSubmit}
                  />
                </Col>
              </Row>
            </Container>
            {errorText && (
              <AlertComp variant="danger" text={errorText} onClose={() => setErrorText("")} />
            )}
          </>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default ProductCanvas;
